// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import router from './router'
//Element
import './element'
//自定义全局组件
import './components/global'
import './assets/styles/reset.scss'
//Svg图标
import './assets/icons'
//自定义element样式 适应移动端
import './assets/styles/element.scss';
import App from './App'
import permission from './router/permission'
Vue.config.productionTip = false
//打印与调试
Vue.prototype.console = console;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js